import React from 'react';
import Issues from '../../../modules/Issues/components/Issues';

const CarePage = () => {
  return (
    <Issues />
  );
};

export default CarePage;